"use strict";

exports.__esModule = true;
exports.default = void 0;

var _navbar = _interopRequireDefault(require("./navbar"));

exports.BNavbar = _navbar.default;

var _navbarNav = _interopRequireDefault(require("./navbar-nav"));

exports.BNavbarNav = _navbarNav.default;

var _navbarBrand = _interopRequireDefault(require("./navbar-brand"));

exports.BNavbarBrand = _navbarBrand.default;

var _navbarToggle = _interopRequireDefault(require("./navbar-toggle"));

exports.BNavbarToggle = _navbarToggle.default;

var _nav = _interopRequireDefault(require("../nav"));

var _collapse = _interopRequireDefault(require("../collapse"));

var _dropdown = _interopRequireDefault(require("../dropdown"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BNavbar: _navbar.default,
  BNavbarNav: _navbarNav.default,
  BNavbarBrand: _navbarBrand.default,
  BNavbarToggle: _navbarToggle.default,
  BNavToggle: _navbarToggle.default
};
var plugins = {
  NavPlugin: _nav.default,
  CollapsePlugin: _collapse.default,
  DropdownPlugin: _dropdown.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components,
    plugins: plugins
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-vue/es/components/navbar/index.js
// module id = Ymj4
// module chunks = 1